export default "__VITE_ASSET__BCM3AcDu__"